/* eslint-disable react/destructuring-assignment */
import React from 'react'

import { Button } from 'gdpp-components/dist/cjs/components/atoms'
import { getGlobalParams, getCustomIntl } from 'config/config'
import { handleFavItems } from 'utils/interaction'
import { dispatchFundListClickFund } from 'utils/tracking'

import Link from '../../../atoms/Link'
import NumberComponent from '../../../atoms/Number'
import CustomeDate from '../../../atoms/Date'
import Dropdown from '../../../atoms/Dropdown'

const intl = getCustomIntl()
const redIsRaise = true
const signDisplay = 'always'
const percentStyle = 'percent'

const actionLabels = {
  favListName: {
    add: 'fundWatchlist.addToFavContent',
    remove: 'fundWatchlist.removeFromFavContent'
  },
  fundComparisonCart: {
    add: 'fundList.menu.shoppingCart.add',
    remove: 'fundList.menu.shoppingCart.remove',
    disabled: 'fundList.menu.shoppingCart.disabled'
  }
}

const handleFundListClick = () => {
  if (document.querySelector('[name="funds-search-box"]') && document.querySelector('[name="funds-search-box"]').value.trim()) {
    const value = document.querySelector('[name="funds-search-box"]').value.trim()
    dispatchFundListClickFund(value)
  }
}

const columns = ({ handleComparisonItems, sortInfo }) => {
  const { favListName, hasFundComparison, fundComparisonCart, comparisonLimit } = getGlobalParams()

  const favItemsStorage = localStorage.getItem(favListName)
  const comparisonItemsStorage = sessionStorage.getItem(fundComparisonCart)
  const favItems = favItemsStorage ? JSON.parse(favItemsStorage) : []
  const comparisonItems = comparisonItemsStorage ? JSON.parse(comparisonItemsStorage) : []

  const defaultSortItem = sortInfo?.sortItem || 'fundname'
  const defaultSortOrder = sortInfo?.sortOrder || 'asc'

  return [
    {
      key: 'fundname',
      title: intl.formatMessage({ id: 'fundList.table.fundName' }),
      type: 'string',
      sortable: true,
      style: { width: '200px' },
      sortDataIndex: 'shareClassName.fomrattedShareClassName',
      ...(defaultSortItem === 'fundname' ? { isDefaultSort: true, sortOrder: defaultSortOrder } : {}),
      cell: {
        extraClasses: 'text-left',
        render: (data) => {
          const { shareClassName, fundOriginalName, shareClassNote, shareClassId } = data
          const value = `${shareClassName.zh}${fundOriginalName ? `(${fundOriginalName})` : ''}`

          return (
            <div>
              <Link
                {...{
                  value,
                  to: `/funds/${shareClassName.fomrattedShareClassName}`,
                  linkState: {
                    shareClassId,
                    fundName: fundOriginalName
                  },
                  followingDisclaimer: shareClassNote,
                  onClick: handleFundListClick
                }}
              />
            </div>
          )
        }
      },
      className: 'text-left'
    },
    {
      key: 'actions',
      title: intl.formatMessage({ id: 'fundList.table.action' }),
      cell: {
        render: (data) => {
          const { shareClassId, documents, shareClassName } = data
          const isAddedToFav = favItems.includes(shareClassId)
          const isAddedToComparison = !!comparisonItems.find((item) => item.shareClassId === shareClassId)
          const isComparisonDisabled = comparisonItems.length >= comparisonLimit && !isAddedToComparison

          return [
            <Dropdown
              id={`funds_${shareClassId}_documents_dropdown`}
              key={`funds_${shareClassId}_documents_dropdown`}
              {...{
                alignment: 'left',
                size: 'standard',
                label: intl.formatMessage({ id: 'fundList.table.downloadRelatedFile' }),
                kind: 'icon',
                icon: 'office-file-pdf-1',
                iconSize: 24,
                extraClasses: 'fil-fund-table--row-action-pdf',
                menu: documents
              }}
            />,
            <div key={`funds_${shareClassId}_fav`}>
              <Button
                {...{
                  kind: 'icon',
                  size: 'standard',
                  icon: 'rating-star-ribbon',
                  iconSize: 24,
                  extraClasses: `fil-fund-table--row-action-fav ${isAddedToFav ? 'added' : ''}`,
                  label: intl.formatMessage({ id: isAddedToFav ? actionLabels.favListName.remove : actionLabels.favListName.add }),
                  onClick: (e) => {
                    handleFavItems(e.currentTarget.classList, shareClassId)
                  }
                }}
              />
            </div>,
            ...(hasFundComparison
              ? [
                  <div key={`funds_${shareClassId}_comparison`}>
                    <Button
                      {...{
                        kind: 'icon',
                        size: 'standard',
                        icon: 'data-file-bars-add',
                        iconSize: 24,
                        extraClasses: `fil-fund-table--row-action-shopping-cart${isAddedToComparison ? ' added' : ''}`,
                        label: intl.formatMessage({
                          id: isComparisonDisabled
                            ? actionLabels.fundComparisonCart.disabled
                            : isAddedToComparison
                            ? actionLabels.fundComparisonCart.remove
                            : actionLabels.fundComparisonCart.add
                        }),
                        onClick: () => {
                          handleComparisonItems({ shareClassId, shareClassName: shareClassName.zh })
                        }
                      }}
                      {...(isComparisonDisabled ? { disabled: true } : {})}
                    />
                  </div>
                ]
              : [])
          ]
        }
      },
      extraClasses: 'text-right no-wrap'
    },
    {
      key: 'nav',
      title: intl.formatMessage({ id: 'fundList.table.nav' }),
      dataIndex: 'price',
      style: { width: '150px' },
      cell: {
        render: (price) => [
          <NumberComponent key="nav" {...{ value: price.nav, fractionDigits: 4, fluctuationColor: false }} />,
          <NumberComponent key="changeAbsolute" {...{ value: price.changeAbsolute, fractionDigits: 4, signDisplay, redIsRaise }} />,
          <NumberComponent
            key="changePercent"
            {...{ value: price.changePercent, fractionDigits: 2, style: percentStyle, signDisplay, redIsRaise }}
          />,
          <CustomeDate key="date" {...{ value: price.date, customFormat: 'yyyy-MM-dd' }} />
        ]
      },
      extraClasses: 'text-right'
    },
    {
      key: 'currency',
      title: intl.formatMessage({ id: 'fundList.table.currency' }),
      style: { width: '100px' },
      dataIndex: 'currency',
      cell: {
        render: (data) => <span>{data.name}</span>
      },
      extraClasses: 'text-right'
    },
    {
      title: intl.formatMessage({ id: 'fundList.table.cumulativeReturn' }),
      extraClasses: 'text-center',
      children: [
        {
          key: 'ytd',
          title: intl.formatMessage({ id: 'fundList.table.YTD' }),
          dataIndex: 'performance',
          ...(defaultSortItem === 'ytd' ? { isDefaultSort: true, sortOrder: defaultSortOrder } : {}),
          sortable: true,
          sortDataIndex: 'performance.cumulativeReturnYTD',
          type: 'number',
          cell: {
            render: (data) => (
              <NumberComponent
                {...{
                  value: data?.cumulativeReturnYTD || data?.cumulativeReturnYTD === 0 ? data.cumulativeReturnYTD : '',
                  fractionDigits: 2,
                  style: percentStyle,
                  signDisplay,
                  redIsRaise
                }}
              />
            )
          },
          extraClasses: 'text-right'
        },
        {
          key: 'month3',
          title: intl.formatMessage({ id: 'fundList.table.monthsText' }, { monthsCount: 3 }),
          dataIndex: 'performance',
          type: 'number',
          sortable: true,
          sortDataIndex: 'performance.cumulativeReturnM3',
          ...(defaultSortItem === 'month3' ? { isDefaultSort: true, sortOrder: defaultSortOrder } : {}),
          cell: {
            render: (data) => (
              <NumberComponent
                {...{
                  value: data?.cumulativeReturnM3 || data?.cumulativeReturnM3 === 0 ? data.cumulativeReturnM3 : '',
                  fractionDigits: 2,
                  style: percentStyle,
                  signDisplay,
                  redIsRaise
                }}
              />
            )
          },
          extraClasses: 'text-right'
        },
        {
          key: 'month6',
          title: intl.formatMessage({ id: 'fundList.table.monthsText' }, { monthsCount: 6 }),
          dataIndex: 'performance',
          type: 'number',
          sortable: true,
          sortDataIndex: 'performance.cumulativeReturnM6',
          ...(defaultSortItem === 'month6' ? { isDefaultSort: true, sortOrder: defaultSortOrder } : {}),
          cell: {
            render: (data) => (
              <NumberComponent
                {...{
                  value: data?.cumulativeReturnM6 || data?.cumulativeReturnM6 === 0 ? data.cumulativeReturnM6 : '',
                  fractionDigits: 2,
                  style: percentStyle,
                  signDisplay,
                  redIsRaise
                }}
              />
            )
          },
          extraClasses: 'text-right'
        },
        {
          key: 'year1',
          title: intl.formatMessage({ id: 'fundList.table.yearsText' }, { yearsCount: 1 }),
          dataIndex: 'performance',
          type: 'number',
          sortable: true,
          sortDataIndex: 'performance.cumulativeReturnY1',
          ...(defaultSortItem === 'year1' ? { isDefaultSort: true, sortOrder: defaultSortOrder } : {}),
          cell: {
            render: (data) => (
              <NumberComponent
                {...{
                  value: data?.cumulativeReturnY1 || data?.cumulativeReturnY1 === 0 ? data.cumulativeReturnY1 : '',
                  fractionDigits: 2,
                  style: percentStyle,
                  signDisplay,
                  redIsRaise
                }}
              />
            )
          },
          extraClasses: 'text-right'
        },
        {
          key: 'year2',
          title: intl.formatMessage({ id: 'fundList.table.yearsText' }, { yearsCount: 2 }),
          dataIndex: 'performance',
          type: 'number',
          sortable: true,
          sortDataIndex: 'performance.cumulativeReturnY2',
          ...(defaultSortItem === 'year2' ? { isDefaultSort: true, sortOrder: defaultSortOrder } : {}),
          cell: {
            render: (data) => (
              <NumberComponent
                {...{
                  value: data?.cumulativeReturnY2 || data?.cumulativeReturnY2 === 0 ? data.cumulativeReturnY2 : '',
                  fractionDigits: 2,
                  style: percentStyle,
                  signDisplay,
                  redIsRaise
                }}
              />
            )
          },
          extraClasses: 'text-right'
        },
        {
          key: 'year3',
          title: intl.formatMessage({ id: 'fundList.table.yearsText' }, { yearsCount: 3 }),
          dataIndex: 'performance',
          type: 'number',
          sortable: true,
          sortDataIndex: 'performance.cumulativeReturnY3',
          ...(defaultSortItem === 'year3' ? { isDefaultSort: true, sortOrder: defaultSortOrder } : {}),
          cell: {
            render: (data) => (
              <NumberComponent
                {...{
                  value: data?.cumulativeReturnY3 || data?.cumulativeReturnY3 === 0 ? data.cumulativeReturnY3 : '',
                  fractionDigits: 2,
                  style: percentStyle,
                  signDisplay,
                  redIsRaise
                }}
              />
            )
          },
          extraClasses: 'text-right'
        },
        {
          key: 'year_max',
          title: intl.formatMessage({ id: 'fundList.table.sinceLaunch' }),
          dataIndex: 'performance',
          type: 'number',
          sortable: true,
          sortDataIndex: 'performance.cumulativeReturnMax',
          ...(defaultSortItem === 'year_max' ? { isDefaultSort: true, sortOrder: defaultSortOrder } : {}),
          cell: {
            render: (data) => (
              <NumberComponent
                {...{
                  value: data?.cumulativeReturnMax || data?.cumulativeReturnMax === 0 ? data.cumulativeReturnMax : '',
                  fractionDigits: 2,
                  style: percentStyle,
                  signDisplay,
                  redIsRaise
                }}
              />
            )
          },
          extraClasses: 'text-right'
        }
      ]
    },
    {
      key: 'updateDate',
      title: intl.formatMessage({ id: 'fundList.table.updateDate' }),
      dataIndex: 'performance',
      style: { width: '180px' },
      cell: {
        render: (data) => <CustomeDate key="date" {...{ value: data?.returnDate || '', customFormat: 'yyyy-MM-dd' }} />
      },
      extraClasses: 'text-right'
    }
  ]
}

export default columns
